import React from "react";
import { Box, Button, Paper, Typography } from "@mui/material";
import SyncIcon from "@mui/icons-material/Sync";
import Swal from "sweetalert2";

import { postRequest } from "Includes/api/apicall";
import { POST_URL } from "Includes/urls";
import { Actions, screenTypes } from "Constants/permissions";

const buildPermissionPayload = () => {
  const rows = [];
  const seenCodes = new Set();

  Object.keys(Actions).forEach((actionKey) => {
    const actionBlock = Actions[actionKey];
    screenTypes.forEach((screenType) => {
      const screen = actionBlock?.[screenType];
      if (!screen?.permission_needed || !screen?.action_code) return;
      if (seenCodes.has(screen.action_code)) return;
      seenCodes.add(screen.action_code);

      rows.push({
        action_code: screen.action_code,
        name: screen.name || screen.label || actionBlock.name || actionKey,
        label: screen.label || actionBlock.name || actionKey,
        type: actionBlock.type || "",
        url: screen.url || "",
      });
    });
  });

  return rows;
};

function PermissionsSyncPage(props) {
  const [loading, setLoading] = React.useState(false);

  const syncPermissions = () => {
    const permissions = buildPermissionPayload();
    setLoading(true);
    postRequest(POST_URL.permissions_sync.api, { permissions }, props)
      .then((response) => {
        if (response && response.status === 200) {
          const data = response?.data?.data || {};
          Swal.fire({
            icon: "success",
            title: "Permissions updated",
            html: `Created: <b>${data.created || 0}</b><br/>Updated: <b>${data.updated || 0}</b><br/>Skipped: <b>${data.skipped || 0}</b>`,
          });
        }
      })
      .finally(() => setLoading(false));
  };

  return (
    <Box sx={{ p: 3 }}>
      <Paper
        elevation={0}
        sx={{
          p: { xs: 2, md: 3 },
          borderRadius: 2,
          border: "1px solid",
          borderColor: "divider",
        }}
      >
        <Typography variant="h5" fontWeight={700}>
          Permissions Sync
        </Typography>
        <Typography variant="body2" color="text.secondary" sx={{ mt: 0.5, mb: 2.5 }}>
          Click update to push all frontend permission codes to backend and save in Django auth permissions table.
        </Typography>
        <Button
          variant="contained"
          startIcon={<SyncIcon />}
          onClick={syncPermissions}
          disabled={loading}
        >
          {loading ? "Updating..." : "Update Permissions"}
        </Button>
      </Paper>
    </Box>
  );
}

export default PermissionsSyncPage;
